import React from 'react';

const ValorMonetario = ({ valor }) => {
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor/100);
  };

  return (
    <>{formatarMoeda(valor)}</>
  );
};

export default ValorMonetario;